export const SetupRouting = [
  {
    path: "/work-manage/setup/list",
    name: "work-manage-setup-list",
    meta: { title: "施工立项" },
    notice: { type: "work_set_up_examine", hasNotice: false },
    component: () => import("@/views/work-manage/setup/list/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/setup/create",
    name: "work-manage-setup-create",
    meta: { title: "新增施工立项" ,comName:"workManageSetupFormCreate"},
    component: () => import("@/views/work-manage/setup/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/setup/edit/:id",
    name: "work-manage-setup-edit",
    meta: { title: "编辑施工立项",comName:"workManageSetupFormCreate" },
    component: () => import("@/views/work-manage/setup/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/setup/detail/:id",
    name: "work-manage-setup-detail",
    meta: { title: "施工立项详情" },
    component: () => import("@/views/work-manage/setup/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/setup/flowPrint/:id",
    name: "work-manage-setup-flow-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/work-manage/setup/flow-print/index.vue"),
  }
];
